<template>
	<div class="setting-box">
    <div class="top">
      <VanImage
        class="avator"
        round
        width="4rem"
        height="4rem"
        :src="avatar"
      />
      <div class="content">
        <p class="title font_14">{{ userName }}</p>
        <p class="text">手机号码：{{ phone }}</p>
      </div>
    </div>
    <div class="split"></div>
    <CellGroup :border="false">
      <Cell v-if="false" title="监管信息" value="努力开发中..." icon="goods-collect-o" size="large" is-link/>
      <Cell @click="toUrl()" title="我的供求" icon="medal-o" size="large" is-link/>
      <Cell title="我的订单" icon="orders-o" size="large" is-link @click="$router.push('/orderList')"/>
    </CellGroup>
    <div class="split"></div>
    <CellGroup :border="false">
      <Cell title="版本" value="1.0.0" icon="apps-o" size="large" is-link/>
    </CellGroup>
  </div>
</template>

<script>
import { Cell, Image as VanImage, CellGroup, Icon } from 'vant';

export default {
  components: {Cell, VanImage, CellGroup, Icon},
  computed: {
    avatar() {
      return this.$store.state.userFromJava.headImage || require('../assets/avatar-default.png');
    },
    userName() {
      return this.$store.state.userFromJava.userName;
    },
    phone() {
      return this.$store.state.userFromJava.phone;
    }
  },
  data () {
    return {
      hzUseRInfo: JSON.parse(localStorage.hzUseRInfo),
    }
  },
  created() {
  },
  mounted() {
    console.log(this.userFromJava)
  },
  methods: {
    toUrl () {
      this.$router.push({
        name: 'tradeLeads',
        query: {
          formUserId: this.hzUseRInfo.id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
	.setting-box {

		.top {
      background-color: #ed143f;
      color: white;
      display: flex;
      align-items: center;
      position: relative;

      .avator {
        margin: 30px 20px;
      }

      .title {
        font-weight: bolder;
      }

      .text {
        font-size: 14px;
      }

      .setting {
        position: absolute;
        top: 25px;
        right: 25px;
      }
		}
	}
</style>
